import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IHttpCoreService } from './core.interface';

@Injectable({
  providedIn: 'root'
})
export class CoreService<T> implements IHttpCoreService<T> {

  constructor(private http: HttpClient) { }

  getAll(endPoint: string) {
    return this.http.get<T[]>(endPoint, {observe: 'body'});
  }

  getByFilters(endPoint: string, filters: any) {
    return this.http.post<T[]>(endPoint, filters, {observe: 'body'});
  }

  getById(endPoint: string, id: number|string): Observable<T> {
    return this.http.get<T>(`${endPoint}${id}`, {observe: 'body'});
  };

  get(endPoint: string): Observable<T> {
    return this.http.get<T>(`${endPoint}`, {observe: 'body'});
  };

  // New: get full HttpResponse including headers
  getResponse(endPoint: string): Observable<HttpResponse<T>> {
    return this.http.get<T>(`${endPoint}`, { observe: 'response' });
  };

  post(endPoint: string, post: any): Observable<T> {
    return this.http.post<T>(endPoint, post, {observe: 'body'});
  };

  put(endPoint: string, post: any, id: number = -1): Observable<T> {
    if (id === -1) {
      id = post['id'];
    }

    return this.http.put<T>(`${endPoint}/${id}`, post, {observe: 'body'});
  };

  bulkPut(endPoint: string, post: any): Observable<T> {
    return this.http.put<T>(`${endPoint}`, post, {observe: 'body'});
  };

  bulkDelete(endPoint: string, post: any): Observable<T> {
    return this.http.post<T>(`${endPoint}`, post, {observe: 'body'});
  };

  delete(endPoint: string): Observable<T> {
    return this.http.request<T>('Delete', endPoint);
  };

}
